import { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, IContext } from '../../types';
import { i18nMap, shouldRender, isAvailable, isBillingLinkPermission } from '../../utils';

export class LocationIntentUpdateNotifications {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account];
  }

  async getLocationIntentUpdateNotifications() {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    const {
      LocationIntentUpdateNotification,
    } = this.context.getCurrentPermissions().dynamic;

    if (!LocationIntentUpdateNotification) {
      return [];
    }

    if (!isAvailable(this.context.getCurrentScope(), this.availableScopes)) {
      return [];
    }

    if (!shouldRender(ScopeLevel.account, this.context.getChangeScope())) {
      return [];
    }

    const notifications: INotification[] = [];

    notifications.push({
      id: 'LocationIntentUpdate',
      condition: true,
      target: TargetComponent.UnifiedQueue,
      dismissMode: DismissMode.permanent,
      severity: NotificationLevel.Info,
      scopeLevel: ScopeLevel.account,
      availableScopes: this.availableScopes,
      title: this.i18n.getString(i18nMap.UnifiedNotificationQueue_Location_Intent_Update_Title),
      message: this.i18n.getString(i18nMap.UnifiedNotificationQueue_Location_Intent_Update_Message),
      actionList: [],
    });


    return notifications;
  }
}
